import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { User } from "@types";
import { useExamStore } from "@store";

export const useGetUser = (enabled: boolean = false) => {

    const axios = useAxios();
    const {t} = useTranslation();
    const setUser = useExamStore(state => state.setCurrentUser);

    const getUser = async () => {
        try {
            const { data } = await axios.get<User>("/api/user/currentUser");
            setUser(data);
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getUser"));
        }
    }

    return useQuery({queryKey: ["user"], queryFn: getUser, enabled, staleTime: Infinity})
}